import { Typography } from "@mui/material";
import { type FC } from "react";

import { MarketAmountField } from "~/feature/event/components/MarketCalculator/components/MarketAmountField";
import { MarketCalculatorQuestion } from "~/feature/event/components/MarketCalculator/components/MarketCalculatorQuestion";
import { MarketCountDown } from "~/feature/event/components/MarketCalculator/components/MarketCountDown";
import {
  TradeOn,
  TradeOnResolved,
} from "~/feature/event/components/MarketCalculator/components/TradeOn";
import { EventPageSections } from "~/feature/event/constants";
import { useMarketCalculator } from "~/feature/event/providers/MarketCalculatorProvider";
import { type IAggregatedEvent, MarketStatus } from "~/types/event";

import * as Styled from "./MarketCalculator.styles";

interface IMarketCalculatorProps {
  event: IAggregatedEvent;
}

export const MarketCalculator: FC<IMarketCalculatorProps> = ({ event }) => {
  const { market } = useMarketCalculator();

  if (!market) return null;

  const isResolvedOrClosed =
    market.unifiedStatus === MarketStatus.CLOSED ||
    market.unifiedStatus === MarketStatus.RESOLVED;

  if (isResolvedOrClosed) {
    return (
      <Styled.Root component="section" id={EventPageSections.MarketCalculator}>
        <MarketCountDown market={market} resolved />
        <Styled.WhiteRoot elevation={0}>
          <TradeOnResolved market={market} event={event} />
        </Styled.WhiteRoot>
      </Styled.Root>
    );
  }

  return (
    <Styled.Root component="section" id="market-calculator">
      <MarketCountDown market={market} />
      <Styled.WhiteRoot elevation={0}>
        <MarketCalculatorQuestion market={market} singleMarket />
        <MarketAmountField />
        <TradeOn event={event} />
        <Typography
          variant="caption"
          sx={{
            color: "text.secondary",
            fontSize: "11px"
          }}>
          You will be redirected to the platform to complete this trade.
        </Typography>
      </Styled.WhiteRoot>
    </Styled.Root>
  );
};
